import {defineStore} from "pinia";

export const generalStore = defineStore({
    id: 'generalStore',
    state: () => {
        return {
            count: 0,
            variables: [],
            covers: [],
            spaCover: null,
            campaignCover: null,
            restosCover: null,
            roomsCover: null,
            eventsCover: null,
            policyCover: null,
            aboutCover: null,
            careerCover: null,
            contactCover: null,
            spaPhotos: null,
            spaSlider: null,
            landingCover: null,
            landingCoverMobile: null,
            restoSlider: null,
            qualityCover: null,
            horizontalSlider: null,
            galleryCover: null,
            roomsPhotos: null,
            activitiesPhotos: null,
            concertsPhotos: null,
            meetingHallsPhotos: null,
            rewardsImages: [],
            banksImages: [],
            sectionImages: [],
            summerConceptEn: null,
            summerConceptTr: null,
            winterConceptEn: null,
            winterConceptTr: null,
            summerConceptCover: null,
            winterConceptCover: null,
            summerConceptEnDesc: null,
            summerConceptTrDesc: null,
            winterConceptEnDesc: null,
            winterConceptTrDesc: null
        }
    },
    actions: {
        increaseCount(inc) {
            inc.count ++
        },
        setVariables(data) {
            this.variables = data;
        },
        setRoomsPhotos(data) {
            // Collect all photos from all rooms
            const allPhotos = [];
            data.forEach(room => {
                if (room.photos) {
                    try {
                        const parsed = JSON.parse(room.photos);
                        if (Array.isArray(parsed)) {
                            allPhotos.push(...parsed);
                        }
                    } catch (e) {
                        console.error('Error parsing room photos:', e);
                    }
                }
            });
            // Shuffle and store as JSON string
            const shuffled = allPhotos.sort(() => Math.random() - 0.5);
            this.roomsPhotos = JSON.stringify(shuffled);
        },
        setRestaurantsPhotos(data) {
            // Collect all photos from all restaurants
            const allPhotos = [];
            data.forEach(restaurant => {
                if (restaurant.photos) {
                    try {
                        const parsed = JSON.parse(restaurant.photos);
                        if (Array.isArray(parsed)) {
                            allPhotos.push(...parsed);
                        }
                    } catch (e) {
                        console.error('Error parsing restaurant photos:', e);
                    }
                }
            });
            // Shuffle and store as JSON string
            const shuffled = allPhotos.sort(() => Math.random() - 0.5);
            this.restoSlider = JSON.stringify(shuffled);
        },
        setActivitiesPhotos(data) {
            // Collect all photos from activities with specific categorization
            const allPhotos = [];
            const concertsPhotos = [];
            const meetingHallsPhotos = [];

            data.forEach((activity, index) => {
                // Index 0: Concerts - store separately (not used in gallery)
                if (index === 0) {
                    if (activity.photos) {
                        try {
                            const parsed = JSON.parse(activity.photos);
                            if (Array.isArray(parsed)) {
                                concertsPhotos.push(...parsed);
                            }
                        } catch (e) {
                            console.error('Error parsing concert photos:', e);
                        }
                    }
                    return;
                }

                // Index 1: Animations & Shows - goes to Activities tab
                if (index === 1) {
                    if (activity.photos) {
                        try {
                            const parsed = JSON.parse(activity.photos);
                            if (Array.isArray(parsed)) {
                                allPhotos.push(...parsed);
                            }
                        } catch (e) {
                            console.error('Error parsing activity photos:', e);
                        }
                    }
                    return;
                }

                // Index 2: Meetings - goes to Meeting Halls tab
                // Index 3: Weddings - goes to Meeting Halls tab
                if (index === 2 || index === 3) {
                    if (activity.photos) {
                        try {
                            const parsed = JSON.parse(activity.photos);
                            if (Array.isArray(parsed)) {
                                meetingHallsPhotos.push(...parsed);
                            }
                        } catch (e) {
                            console.error('Error parsing meeting halls photos:', e);
                        }
                    }
                    return;
                }
            });

            // Shuffle and store all three as JSON strings
            const shuffledActivities = allPhotos.sort(() => Math.random() - 0.5);
            const shuffledConcerts = concertsPhotos.sort(() => Math.random() - 0.5);
            const shuffledMeetings = meetingHallsPhotos.sort(() => Math.random() - 0.5);

            this.activitiesPhotos = JSON.stringify(shuffledActivities);
            this.concertsPhotos = JSON.stringify(shuffledConcerts);
            this.meetingHallsPhotos = JSON.stringify(shuffledMeetings);
        },
        setCovers(data) {
            this.covers = data
            if (data.length > 1) {
                this.spaCover = data[0].image_url
                this.campaignCover = data[1].image_url
                this.restosCover = data[2].image_url
                this.roomsCover = data[3].image_url
                this.aboutCover = data[4].image_url
                this.careerCover = data[5].image_url
                this.policyCover = data[6].image_url
                this.eventsCover = data[7].image_url
                this.contactCover = data[8].image_url
                this.spaPhotos = data[9].image_url
                this.landingCover = data[10].image_url
                this.landingCoverMobile = data[10].mobile_image_url || null
                this.spaSlider = data[11].image_url
                this.restoSlider = data[12].image_url
                this.qualityCover = data[13].image_url

                // Find horizontal carousel by name
                const horizontalCarousel = data.find(item => item.name === 'horizontal')
                this.horizontalSlider = horizontalCarousel ? horizontalCarousel.image_url : null

                // Find gallery cover by name (salamis_photos or use first horizontal image)
                const galleryCoverCarousel = data.find(item => item.name === 'salamis_photos')
                this.galleryCover = galleryCoverCarousel ? galleryCoverCarousel.image_url : (this.horizontalSlider ? this.horizontalSlider : null)

                // Rewards carousel — image_url is a JSON-encoded array of storage paths.
                const rewardsCarousel = data.find(item => item.name === 'rewards')
                if (rewardsCarousel && rewardsCarousel.image_url) {
                    try {
                        const parsed = typeof rewardsCarousel.image_url === 'string'
                            ? JSON.parse(rewardsCarousel.image_url)
                            : rewardsCarousel.image_url
                        this.rewardsImages = Array.isArray(parsed) ? parsed : []
                    } catch (e) {
                        console.error('Error parsing rewards image_url:', e)
                        this.rewardsImages = []
                    }
                } else {
                    this.rewardsImages = []
                }

                // Concept PDFs — file is JSON: [{"download_link":"...","original_name":"..."}]
                const parseConceptFile = (raw) => {
                    if (!raw) return null
                    try {
                        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
                        const item = Array.isArray(parsed) ? parsed[0] : parsed
                        if (!item?.download_link) return null
                        return {
                            url: `https://api2.salamisbayconti.com/storage/${item.download_link.replace(/\/+/g, '/')}`,
                            name: item.original_name || null
                        }
                    } catch { return null }
                }

                const summerEn = data.find(item => item.name === 'summer-concept-en')
                this.summerConceptEn = parseConceptFile(summerEn?.file)
                this.summerConceptEnDesc = summerEn?.desc || null

                const summerTr = data.find(item => item.name === 'summer-concept-tr')
                this.summerConceptTr = parseConceptFile(summerTr?.file)
                this.summerConceptTrDesc = summerTr?.desc || null

                const winterEn = data.find(item => item.name === 'winter-concept-en')
                this.winterConceptEn = parseConceptFile(winterEn?.file)
                this.winterConceptEnDesc = winterEn?.desc || null

                const winterTr = data.find(item => item.name === 'winter-concept-tr')
                this.winterConceptTr = parseConceptFile(winterTr?.file)
                this.winterConceptTrDesc = winterTr?.desc || null

                const parseCarouselImage = (raw) => {
                    if (!raw) return null
                    try {
                        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
                        const path = Array.isArray(parsed) ? parsed[0] : parsed
                        if (typeof path === 'string') return `https://api2.salamisbayconti.com/storage/${path}`
                    } catch { /* fall through */ }
                    if (typeof raw === 'string' && raw.startsWith('http')) return raw
                    if (typeof raw === 'string') return `https://api2.salamisbayconti.com/storage/${raw}`
                    return null
                }

                const summerCover = data.find(item => item.name === 'summer-consept')
                this.summerConceptCover = parseCarouselImage(summerCover?.image_url)

                const winterCover = data.find(item => item.name === 'winter-consept')
                this.winterConceptCover = parseCarouselImage(winterCover?.image_url)

                // Banks carousel — same shape as rewards. Order in array drives
                // display order on the installment-options page.
                const banksCarousel = data.find(item => item.name === 'banks')
                if (banksCarousel && banksCarousel.image_url) {
                    try {
                        const parsed = typeof banksCarousel.image_url === 'string'
                            ? JSON.parse(banksCarousel.image_url)
                            : banksCarousel.image_url
                        this.banksImages = Array.isArray(parsed) ? parsed : []
                    } catch (e) {
                        console.error('Error parsing banks image_url:', e)
                        this.banksImages = []
                    }
                } else {
                    this.banksImages = []
                }

                // "section" carousel (admin panel) — same shape as rewards/banks.
                // Feeds BarSection's image cycler on the homepage.
                const sectionCarousel = data.find(item => item.name === 'section')
                if (sectionCarousel && sectionCarousel.image_url) {
                    try {
                        const parsed = typeof sectionCarousel.image_url === 'string'
                            ? JSON.parse(sectionCarousel.image_url)
                            : sectionCarousel.image_url
                        this.sectionImages = Array.isArray(parsed) ? parsed : []
                    } catch (e) {
                        console.error('Error parsing section image_url:', e)
                        this.sectionImages = []
                    }
                } else {
                    this.sectionImages = []
                }
            }
        }
    },
    getters: {
        getVariable : (state) =>{
            return (key) => {
                const filtered = state.variables.filter(item => item.key === key);
                if(filtered.length > 0 ){
                    return filtered[0].value
                }else{
                    return 'Loading...'
                }
            }
        },
        getCount(state) {
            return state.count
        },
        getVariables(state) {
            return state.variables
        },
        getCovers(state) {
            return state.covers
        },
        getSpaCover(state) {
            return state.spaCover
        }   ,
        getCampaignCover(state) {
            return state.campaignCover
        },
        getRestosCover(state) {
            return state.restosCover
        },
        getRoomsCover(state) {
            return state.roomsCover
        },
        getEventscover(state) {
            return state.eventsCover
        },
        getPolicyCover(state) {
            return state.policyCover
        },
        getQualityCover(state) {
            return state.qualityCover
        },
        getAboutCover(state) {
            return state.aboutCover
        },
        getCareerCover(state) {
            return state.careerCover
        },
        getContactCover(state) {
            return state.contactCover
        },
        getSpaImages(state) {
            return state.spaPhotos
        },
        getSpaSlider(state) {
            return state.spaSlider
        },
        getLandingCover(state) {
            return state.landingCover
        },
        getLandingCoverMobile(state) {
            return state.landingCoverMobile
        },
        getRestoSlider(state) {
            return state.restoSlider
        },
        getHorizontalSlider(state) {
            return state.horizontalSlider
        },
        getGalleryCover(state) {
            return state.galleryCover
        },
        getRoomsPhotos(state) {
            return state.roomsPhotos
        },
        getActivitiesPhotos(state) {
            return state.activitiesPhotos
        },
        getConcertsPhotos(state) {
            return state.concertsPhotos
        },
        getMeetingHallsPhotos(state) {
            return state.meetingHallsPhotos
        },
        getRewardsImages(state) {
            return state.rewardsImages
        },
        getBanksImages(state) {
            return state.banksImages
        },
        getSectionImages(state) {
            return state.sectionImages
        },
        getSummerConceptEn(state) {
            return state.summerConceptEn
        },
        getSummerConceptTr(state) {
            return state.summerConceptTr
        },
        getWinterConceptEn(state) {
            return state.winterConceptEn
        },
        getWinterConceptTr(state) {
            return state.winterConceptTr
        },
        getSummerConceptCover(state) {
            return state.summerConceptCover
        },
        getWinterConceptCover(state) {
            return state.winterConceptCover
        },
        getSummerConceptEnDesc(state) {
            return state.summerConceptEnDesc
        },
        getSummerConceptTrDesc(state) {
            return state.summerConceptTrDesc
        },
        getWinterConceptEnDesc(state) {
            return state.winterConceptEnDesc
        },
        getWinterConceptTrDesc(state) {
            return state.winterConceptTrDesc
        },

    },

})
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(generalStore, import.meta.hot))
}
